module.exports = __webpack_public_path__ + "img/weingutloewenstein_3.1779b08a.jpg";